import * as R from 'ramda'
import { createSelector } from 'reselect'

import { NOTIFICATION_LEVELS_SORT_ORDER } from './constants'

const emptyArray = []

const getNotifications = ({ notifications: { list = emptyArray } = {} }) => list

const getFilteredNotifications = createSelector(
  getNotifications,
  notifications => R.memoizeWith(
    R.identity,
    type => notifications.filter(R.propEq('type', type))
  )
)
const getSortedFilteredNotifications = createSelector(
  getFilteredNotifications,
  filteredNotifications => R.memoizeWith(
    R.identity,
    type => {
      return filteredNotifications(type)
        .sort(({ level: levelOne }, { level: levelTwo }) => {
          return NOTIFICATION_LEVELS_SORT_ORDER[levelOne] - NOTIFICATION_LEVELS_SORT_ORDER[levelTwo]
        })
    }
  )
)

export {
  getNotifications,
  getFilteredNotifications,
  getSortedFilteredNotifications
}
